module.exports = __webpack_public_path__ + "img/tecnomodel_white_logo.1297c1b3.png";